import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { registerServiceWorker } from './registerSW';
import './styles/reset.css';
import './styles/tokens.css';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// SPEC-SPATIAL-MAPS §11: the primary Cloudflare-V3 service worker (`/sw.js`)
// already implements tile caching + offline fallback. The spatial-only
// `/sw-spatial.js` is shipped as a drop-in for split-domain deployments
// but NOT auto-registered here to avoid clobbering the active SW.
registerServiceWorker();
